import ShopifyObject from '@grafikr/shopify-typescript/global/Shopify';
import Product from '@grafikr/shopify-typescript/type/object/Product';
import Variant from '@grafikr/shopify-typescript/type/object/Variant';
import { component } from 'picoapp';

declare const Shopify: ShopifyObject;

export default component((node: HTMLElement) => {
  const data: Product = JSON.parse(node.querySelector('.js-data').innerHTML);

  const initOptions = () => {
    const addToCart: HTMLButtonElement = node.querySelector('.js-add-to-cart');
    const price: HTMLElement = node.querySelector('.js-price');
    const compareAtPrice: HTMLElement = node.querySelector('.js-compare-at-price');

    const callback = (variant: Variant) => {
      if (variant) {
        price.innerHTML = Shopify.formatMoney(variant.price, theme.moneyFormat);

        if (variant.compare_at_price > variant.price) {
          compareAtPrice.hidden = false;
          compareAtPrice.innerHTML = Shopify.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat,
          );
        } else {
          compareAtPrice.hidden = true;
        }

        if (variant.available) {
          addToCart.innerHTML = theme.strings.addToCart;
          addToCart.disabled = false;
        } else {
          addToCart.innerHTML = theme.strings.soldOut;
          addToCart.disabled = true;
        }
      } else {
        addToCart.innerHTML = theme.strings.unavailable;
        addToCart.disabled = true;
      }
    };

    const init = () => new Shopify.OptionSelectors(`product-${data.id}`, {
      product: data,
      onVariantSelected: callback,
      enableHistoryState: true,
    });

    init();

    const changeVariant = () => {
      const optionSelects: NodeListOf<HTMLSelectElement> = document.querySelectorAll('[data-option-selector]');
      const trueOptionSelects: NodeListOf<HTMLSelectElement> = document.querySelectorAll('.single-option-selector');

      optionSelects.forEach((select) => {
        const { option } = select.dataset;
        const trueSelect = Array.from(trueOptionSelects).find((ts) => ts.dataset.option === option);

        select.addEventListener('change', () => {
          trueSelect.value = select.value;
          const event = new Event('change');
          trueSelect.dispatchEvent(event);
        });
      });
    };
    changeVariant();
  };

  initOptions();
});
